/* @ngInject */
const user = (
  authService,
  accountRequest,
  accountData,
  toaster,
  utils,
  $state
) => {
  const self = {}

  self.isLog = () => {
    return authService.isLog()
  }

  self.register = (_username, _password, _admin) => {
    return accountRequest.register(_username, _password, _admin)
  }

  self.login = (_username, _password) => {
    return accountRequest.login(_username, _password)
  }

  self.logout = () => {
    authService.logout()
    $state.go('index')
  }

  self.changePassword = (_username, _oldPassword, _newPassword) => {
    return accountRequest.changePassword(_username, _oldPassword, _newPassword)
  }

  self.delete = (_username) => {
    console.log(_username)
    const _id = _username.id
    if (_username.username) {
      _username = _username.username
    }
    accountRequest.delete(_id)
      .then((message) => {
        toaster.message(message)
        utils.removeFrom(accountData.currents, 'username', _username)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  self.remove = (_username) => {
    if (_username.username) {
      _username = _username.username
    }
    return accountRequest.delete(_username)
  }

  return self
}

export default user



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/services/user.service.js